exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".item-description h4{padding:.5em 15px;margin:0 0 .75em;box-shadow:0 0 3px rgba(86,96,117,.7);text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/css-loader!/builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/sass-loader!./js/css/item-description.scss
// module id = 73
// module chunks = 0